import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { getCurrencySymbol } from '@angular/common';
import { ConfigurationPage } from '../../configuration';
import { ConfigurationEstablishmentDeletePage } from '../configuration-establishment-delete/configuration-establishment-delete';

/**
 * Generated class for the ConfigurationEstablishmentCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-establishment-create',
  templateUrl: 'configuration-establishment-create.html',
})
export class ConfigurationEstablishmentCreatePage {

  public form: FormGroup;
  update_state: boolean = false;
  restaurant: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,
    public alertCtrl: AlertController) {

    this.globals.GAtrackView('Configuration', 'Configuration - Establishment - View', this.globals.restaurant.email, 'View', 'View Establishment', 'Configuration', '');


    //Params
    this.update_state = this.navParams.get('update_state');
    this.restaurant = this.navParams.get('restaurant');

    if (this.restaurant.email_general_active == undefined) {
      this.restaurant.email_general_active = true;
    }

    if (this.restaurant.email_not_new_tk_order == undefined) {
      this.restaurant.email_not_new_tk_order = true;
    }

    if (this.restaurant.email_not_new_reservation == undefined) {
      this.restaurant.email_not_new_reservation = true;
    }

    if (this.restaurant.email_not_new_valoration == undefined) {
      this.restaurant.email_not_new_valoration = true;
    }

    this.form = fb.group({
      company: [this.restaurant.company, Validators.compose([Validators.required])],
      name: [this.restaurant.name],
      fiscal_name: [this.restaurant.fiscal_name],
      cif: [this.restaurant.cif],
      address: [this.restaurant.address],
      business: [this.restaurant.business],
      business2: [this.restaurant.business2],
      cuisine: [this.restaurant.cuisine],
      cuisine2: [this.restaurant.cuisine2],
      phone: [this.restaurant.phone],
      email: [this.restaurant.email],
      web: [this.restaurant.web],
      currency: [this.restaurant.currency],
      tax_name: [this.restaurant.tax_name],
      tax_percentage: [this.restaurant.tax_percentage, Validators.compose([Validators.required])],
      timezone: [this.restaurant.timezone],
      tickets: [this.restaurant.tickets],
      lang: [this.restaurant.lang],
      format_time: [this.restaurant.format_time],
      format_date: [this.restaurant.format_date],
      email_reservations: [this.restaurant.email_reservations || this.restaurant.email],
      email_takeaway: [this.restaurant.email_takeaway || this.restaurant.email],
      email_ratings: [this.restaurant.email_ratings || this.restaurant.email],
      email_general: [this.restaurant.email_general || this.restaurant.email],
      email_general_active: [this.restaurant.email_general_active],
      email_not_new_tk_order: [this.restaurant.email_not_new_tk_order],
      email_not_new_reservation: [this.restaurant.email_not_new_reservation],
      email_not_new_valoration: [this.restaurant.email_not_new_valoration],
      iban_number: [this.restaurant.iban_number]
    });
  }

  submit() {
    if (this.form.valid) {
      if (this.update_state) {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-introduce-todos-datos-obligatorios'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  update() {
    this.configurationServices.afs.collection('restaurants').doc(this.restaurant.UID).update({
      'company': this.form.value.company,
      'name': this.form.value.name,
      'fiscal_name': this.form.value.fiscal_name,
      'cif': this.form.value.cif,
      'address': this.form.value.address,
      'business': this.form.value.business,
      'business2': this.form.value.business2,
      'cuisine': this.form.value.cuisine,
      'cuisine2': this.form.value.cuisine2,
      'phone': this.form.value.phone,
      'email': this.form.value.email,
      'web': this.form.value.web,
      'currency': this.form.value.currency,
      'tax_name': this.form.value.tax_name,
      'tax_percentage': this.form.value.tax_percentage,
      'timezone': this.form.value.timezone,
      'tickets': this.form.value.tickets,
      'lang': this.form.value.lang,
      'format_time': this.form.value.format_time,
      'format_date': this.form.value.format_date,
      'email_reservations': this.form.value.email_reservations,
      'email_takeaway': this.form.value.email_takeaway,
      'email_ratings': this.form.value.email_ratings,
      'email_general_active': this.form.value.email_general_active,
      'email_general': this.form.value.email_general,
      'email_not_new_tk_order': this.form.value.email_not_new_tk_order,
      'email_not_new_reservation': this.form.value.email_not_new_reservation,
      'email_not_new_valoration': this.form.value.email_not_new_valoration,
      'iban_number': this.form.value.iban_number
    }).then(() => {
      this.globals.GAtrackView('Configuration', 'Configuration - Establishment - Update', this.globals.restaurant.email, 'Create/Update', 'Update establishment', 'Configuration', this.form.value.name);
      this.globals.restaurant.company = this.form.value.company;
      this.globals.restaurant.name = this.form.value.name;
      this.globals.restaurant.lang = this.form.value.lang;
      this.globals.RESTAURANT_TAX = this.form.value.tax_percentage;
      this.globals.user_tax_name = this.form.value.tax_name;
      this.globals.user_tax = this.form.value.tax_percentage;
      this.globals.currency_lang = this.globals.checkCurrencyLang(this.form.value.lang);
      this.globals.restaurant.format_time = this.form.value.format_time;
      this.globals.restaurant.format_date = this.form.value.format_date;
      this.globals.restaurant.fiscal_name = this.form.value.fiscal_name;
      this.globals.restaurant.cif = this.form.value.cif;
      this.globals.restaurant.address = this.form.value.address;
      this.globals.restaurant.phone = this.form.value.phone;
      this.globals.restaurant.email_reservations = this.form.value.email_reservations;
      this.globals.restaurant.email_takeaway = this.form.value.email_takeaway;
      this.globals.restaurant.email_ratings = this.form.value.email_ratings;
      this.globals.restaurant.email_general_active = this.form.value.email_general_active;
      this.globals.restaurant.email_general = this.form.value.email_general;
      this.globals.restaurant.email_not_new_tk_order = this.form.value.email_not_new_tk_order;
      this.globals.restaurant.email_not_new_reservation = this.form.value.email_not_new_reservation;
      this.globals.restaurant.email_not_new_valoration = this.form.value.email_not_new_valoration;
      this.globals.restaurant.iban_number = this.form.value.iban_number;

      //set translate
      this.globals.setTranslate();
      //Save user currency
      var str = this.form.value.currency;
      this.globals.user_currency = str.substring(str.lastIndexOf("(") + 1,
        str.lastIndexOf(")"));
      //

      this.globals.currency_symbol = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');

      this.globals.AdressApi(this.form.value.address, this.globals.restaurant_uid, 'conf');
      this.goBack();
    });
  }

  public handleAddressChange(address) {
    this.form.value.address = address.formatted_address;
  }

  goBack() {
    this.globals.side_menu_config_active = '';
    if (this.navCtrl.canGoBack())
      this.navCtrl.pop();
    else
      this.navCtrl.setRoot(ConfigurationPage);
  }

  async openStripePortal() {
    if (this.globals.restaurant.stripe_customer_id != undefined && this.globals.restaurant.stripe_customer_id != '') {
      var portal_url = await this.globals.getStripeCustomerPortal();
      if (this.globals.so_mobile) {
        window.location.assign(portal_url['customer_portal_url']);
      } else {
        window.open(portal_url['customer_portal_url'], '_blank');
      }
    }
  }

  deleteAccount() {
    if (this.globals.user_rol === 'admin') {
      //admin
      this.navCtrl.push(ConfigurationEstablishmentDeletePage);
    } else {
      //caso en no admin
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-accion-solo-administrador'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-establishment/configuration-establishment-create/configuration-establishment-create.ts